import { Route } from '@angular/router';

export const DATA_DELETION_ROUTE: Route = {
  path: 'data-deletion',
  loadChildren: () => import('./data-deletion.module').then(m => m.DataDeletionModule)
};
